<template>
    <div class="feedbacks">
        <div class="content-wrap">
            <h2 class="feedbacks-title">{{ title }} <span>{{ getComments && getComments.length > 0 ? getComments.length : '' }}</span></h2>
            <div class="feedbacks-body">
                <InputField @sendData="sendData($event)" :placeholder="placeholder" />
                <Feedback 
                    v-for="(feedback, index) in getComments" 
                    :feedback="feedback" 
                    :key="index"
                    @setSettings="setSettings"
                />
            </div>
        </div>
        <Choise 
            v-if="choisen"
            :variables="getChoise" 
            @close="choisen = null" 
            @choise="choiseHandler" 
        />
    </div>
</template>
<script>

export default {
    name: 'Feedbacks',
    props: {
        title: {
            type: String,
            default: 'Комментарии'
        },
        placeholder: {
            type: String
        },
        event: {
            type: Object,
            required: false
        },
        place: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            feedbacks: [],
            choisen: null
        }
    },
    computed: {
        getChoise() {
            return [
                // {
                //     name: 'edit',
                //     warning: true,
                //     title: 'Редактировать'
                // },
                {
                    name: 'delete',
                    warning: true,
                    title: 'Удалить'
                },
            ]
        },
        getUser() {
            return this.$store.getters.getAuthUser
        },
        getComments() {
            return this.event 
                ? this.event.comments.filter(comment => !comment.reply_id && !comment.parent_id)
                : this.place.comments.filter(comment => !comment.reply_id && !comment.parent_id)
        }
    },
    components: {
        Feedback: () => import('./components/Feedback'),
        InputField: () => import('./components/InputField'),
        Choise: () => import("@/components/Modals/Choise"),
    },
    methods: {
        async sendData(value) {
            if (this.getUser) {

                let comment = {
                    event: this.event,
                    place: this.place,
                    event_id: this.event ? this.event.id : null,
                    place_id: this.place ? this.place.id : null,
                    content: value,
                }
                let created = this.event 
                    ? await this.$store.dispatch('sendEventComment', comment)
                    : await this.$store.dispatch('sendPlaceComment', comment);
                this.event ? this.event.comments.push(created) : this.place.comments.push(created)
            } else {
                this.$router.push('/login')
                this.$store.dispatch('addNotification', {message: 'Чтобы выполнить это действие, войдите со своим аккаунтом. 😉'})
            }
        },
        setSettings (val) {
            this.choisen = val.feedback
        },
        choiseHandler (val) {
            let type = this.choisen.event_id ? 'events' : 'places'; 
            switch (val.name) {
                // case 'edit':
                //     this.editComment(type)
                //     break;
            
                case 'delete':
                    this.deleteComment(type)
                    break;
            }
            this.choisen = null
        },
        deleteComment(type) {
            this.$axios.post(`/api/${type}/comment/delete`, {comment_id: this.choisen.id})
                .then(res => {
                    this.removeComment(res.data)
                })
                .catch(() => {
                    this.$store.dispatch('addError', { message: `Что-то пошло не так`})
                })
        },
        // editComment(type) {
        //     this.$axios.post(`/api/${type}/comment/edit`, {comment_id: this.choisen.id})
        //         .then(res => {
        //             this.editsComment(res.data)
        //         })
        //         .catch(() => {
        //             this.$store.dispatch('addError', { message: `Что-то пошло не так`})
        //         })
        // },
        removeComment(comment) {
            let feedbacks = this.event ? this.event.comments : this.place.comments;
            if (comment.reply_id) {
                let parent = feedbacks.find(parent => parent.id == comment.reply_id || parent.id == comment.parent_id);
                let finded = parent ? parent.childs.find(child => child.id === comment.id) : '';
                parent.childs.splice(parent.childs.indexOf(finded), 1)
            } else {
                let finded = feedbacks.find(feedback => feedback.id == comment.id);
                feedbacks.splice(feedbacks.indexOf(finded), 1)
            }
        },
        // editsComment(comment) {
        //     let feedbacks = this.event ? this.event.comments : this.place.comments;
        //     if (comment.reply_id) {
        //         let parent = feedbacks.find(parent => parent.id == comment.reply_id || parent.id == comment.parent_id);
        //         let finded = parent ? parent.childs.find(child => child.id === comment.id) : '';
        //         finded.content = comment.content
        //     } else {
        //         let finded = feedbacks.find(feedback => feedback.id === comment.id);
        //         finded.content = comment.content
        //     }
        // },
    }
}
</script>
<style lang="stylus" scoped>
.feedbacks
    width 100%
    margin-top 25px
    &-title
        font-size 24px
        font-weight 600
        padding-bottom 40px
        span
            color #ced2d8
    &-body
        padding-right 40px
        .inputfield
            margin-bottom 20px
</style>